// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/articles/image-articlre-banner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.articles_banner {
    background: var(--couleur-principale);
    height: 134px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    border-radius: 30px;
}

.articles_banner::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    opacity: 0.4;
    z-index: 0;
}

.articles_banner>* {
    position: relative;
    z-index: 1;
}

.articles_banner_content {
    text-align: center;
    color: var(--white-principale);
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.articles_banner_content h1 {
    font-size: 24px;
}

.articles_banner_cta_button {
    background-color: var(--white-principale);
    color: var(--couleur-secondaire);
    padding: 7px;
    border-radius: 15px;
    font-weight: 700;
    transition: background-color 0.3s ease;
    min-width: 224px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
}

.articles_banner_cta_button i {
    font-size: 20px;
    /* margin-right: 10px; */
}

.articles_banner_cta_button span {
    margin-left: 5px;
    font-size: 15px;

}

.articles_banner_cta_button:hover {
    background-color: var(--couleur-secondaire);
    color: var(--white-principale) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/article/ArticleBanner.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,yDAAkF;IAClF,sBAAsB;IACtB,2BAA2B;IAC3B,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yCAAyC;IACzC,gCAAgC;IAChC,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,2CAA2C;IAC3C,yCAAyC;AAC7C","sourcesContent":[".articles_banner {\n    background: var(--couleur-principale);\n    height: 134px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    overflow: hidden;\n    border-radius: 30px;\n}\n\n.articles_banner::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background-image: url('../../../assets/images/articles/image-articlre-banner.png');\n    background-size: cover;\n    background-position: center;\n    opacity: 0.4;\n    z-index: 0;\n}\n\n.articles_banner>* {\n    position: relative;\n    z-index: 1;\n}\n\n.articles_banner_content {\n    text-align: center;\n    color: var(--white-principale);\n    z-index: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.articles_banner_content h1 {\n    font-size: 24px;\n}\n\n.articles_banner_cta_button {\n    background-color: var(--white-principale);\n    color: var(--couleur-secondaire);\n    padding: 7px;\n    border-radius: 15px;\n    font-weight: 700;\n    transition: background-color 0.3s ease;\n    min-width: 224px;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n}\n\n.articles_banner_cta_button i {\n    font-size: 20px;\n    /* margin-right: 10px; */\n}\n\n.articles_banner_cta_button span {\n    margin-left: 5px;\n    font-size: 15px;\n\n}\n\n.articles_banner_cta_button:hover {\n    background-color: var(--couleur-secondaire);\n    color: var(--white-principale) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
